import React from 'react'
import ArrowIcon from '~/components/main-page/TailoredSolutions/animated-icons/ArrowIcon'
import StarIcon from '~/components/main-page/TailoredSolutions/animated-icons/StarIcon'
import ChangeIcon from '~/components/main-page/TailoredSolutions/animated-icons/ChangeIcon'
import { trackEvent } from '~/utils/tracking'
import { CrossIcon } from '~/components/icons'
import { FlexContainer } from '~/components/Grid'
import { createOptimizedContentfulImage } from '~/libs/contentful/helpers'
import type { AssetFields, AssetFile } from 'contentful'

interface CardItemProps {
  bookmark: {
    id: string
    title: string | undefined
    link: string | undefined
    height: string
    backgroundImage: AssetFields | undefined
    backgroundColor: string
    description: string | undefined
  }
  blockId: string
}

const Card: React.FC<CardItemProps> = ({ bookmark, blockId }) => {
  const handleCardMouseEnterEvent = () => {
    trackEvent('homepage_solutions_expanded', {
      block: blockId,
      homepage_solution_title: bookmark.title as string,
    })
  }

  const handleCardClickEvent = () => {
    trackEvent('homepage_solutions_click', {
      block: blockId,
      homepage_solution_title: bookmark.title as string,
    })
  }

  return (
    <a
      className="tailored-solutions__container max-xl:max-h-[66px] flex-col flex relative overflow-hidden justify-between max-h-[640px] w-full rounded-[48px] group"
      style={{
        height: bookmark.height,
        backgroundImage: `url(${createOptimizedContentfulImage({ file: bookmark.backgroundImage?.file as AssetFile })})`,
        backgroundColor: bookmark.backgroundColor,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
      }}
      href={bookmark.link}
      onClick={handleCardClickEvent}
      onMouseEnter={handleCardMouseEnterEvent}
    >
      <FlexContainer className="relative items-center min-h-16 py-5 px-6 overflow-hidden max-xl:py-2 max-xl:px-4">
        {bookmark.id === 'land' && (
          <>
            <ArrowIcon />
          </>
        )}
        {bookmark.id === 'excel' && (
          <>
            <StarIcon />
          </>
        )}
        {bookmark.id === 'stay' && (
          <>
            <ChangeIcon />
          </>
        )}
      </FlexContainer>
      <FlexContainer
        className="absolute bottom-6 flex-col gap-3 max-xl:static"
        style={{ transition: 'transform .35s ease' }}
      >
        <div
          className={
            'animated-title flex xl:group-hover:bottom-[100%] text-m max-xl:p-[0px_23px_0px_66px] max-xl:bottom-1/2 max-xl:translate-y-1/2 absolute bottom-0 items-center cursor-pointer w-full p-[0px_23px_0_32px]'
          }
          style={{ transition: 'bottom .4s cubic-bezier(.51,.92,.24,1.15)' }}
        >
          <span className="flex-grow max-xl:text-tablet-s">{bookmark.title}</span>
          <CrossIcon
            className="w-[initial] h-[initial] group-hover:opacity-0"
            style={{
              opacity: 1,
              transition: 'opacity .3s ease, transform .3s ease',
            }}
          />
        </div>
        <p
          className="animated-text opacity-0 max-xl:hidden py-0 pr-6 pl-8 text-mobile-s group-hover:opacity-100"
          style={{ transition: 'opacity 0.1s ease-out 0.08s' }}
        >
          {bookmark.description}
        </p>
      </FlexContainer>
    </a>
  )
}

export default Card
